import { render } from "./BnPreloader.vue?vue&type=template&id=451ee92e&scoped=true"
import script from "./BnPreloader.vue?vue&type=script&lang=js"
export * from "./BnPreloader.vue?vue&type=script&lang=js"

import "./BnPreloader.vue?vue&type=style&index=0&id=451ee92e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451ee92e"]])

export default __exports__